var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section-action-button-container exception" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible",
            },
          ],
          staticClass: "mt-2 section-action-buttons disable-selection no-print",
          attrs: { id: `section-action-buttons-${_vm.sectionId}` },
        },
        [
          _vm.contentRestrictions.aiNavigationSectionRestrictions.canShowIcon
            ? _c(
                "v-menu",
                {
                  attrs: {
                    "offset-y": "",
                    transition: "scale-transition",
                    "min-width": "220",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c("v-tooltip", {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({
                                      on: tooltipOn,
                                      attrs: tooltipAttrs,
                                    }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  icon: "",
                                                  small: "",
                                                  rounded: "",
                                                },
                                                on: { click: _vm.ainClicked },
                                              },
                                              "v-btn",
                                              { ...attrs, ...tooltipAttrs },
                                              false
                                            ),
                                            { ...on, ...tooltipOn }
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "text--secondary",
                                              },
                                              [_vm._v("mdi-navigation-outline")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "default",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "py-1 px-3 d-flex align-center",
                                          },
                                          [
                                            !_vm.contentRestrictions
                                              .aiNavigationSectionRestrictions
                                              .canUseAiFunctions
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "mr-1",
                                                    attrs: {
                                                      color: "white",
                                                      small: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                mdi-lock-outline\n                            "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v("AI Navigator"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    4209942998
                  ),
                },
                [
                  _vm._v(" "),
                  !_vm.hasAiNavAccess
                    ? _c("ain-premium-required-dialog", {
                        attrs: { isDialogActive: _vm.displayAinRequiredDialog },
                        on: {
                          "update:isDialogActive": function ($event) {
                            _vm.displayAinRequiredDialog = $event
                          },
                          "update:is-dialog-active": function ($event) {
                            _vm.displayAinRequiredDialog = $event
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasAiNavAccess
                    ? _c(
                        "v-card",
                        [
                          _c(
                            "v-card-title",
                            { staticClass: "subtitle-2 font-weight-bold pb-2" },
                            [
                              _vm._v(
                                "\n                    AI Navigator\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-list-item",
                                { on: { click: _vm.askQuestion } },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c("v-icon", [
                                        _vm._v("mdi-message-outline"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Ask question"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                { on: { click: _vm.summarizeSection } },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c("v-icon", [
                                        _vm._v("mdi-format-list-bulleted"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Summarize section"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("ToolBarActionButton", {
            attrs: {
              icon: "mdi-content-copy",
              label: "Copy text",
              iconClass: "trigger-copy-action text--secondary",
              allowed: _vm.contentRestrictions.canCopy,
            },
            on: {
              action: function ($event) {
                return _vm.$emit("copy")
              },
            },
          }),
          _vm._v(" "),
          _c("ToolBarActionButton", {
            attrs: {
              icon: "mdi-bookmark-plus-outline",
              label: "Add note or bookmark",
              iconClass: "trigger-bookmark-action text--secondary",
              allowed: _vm.contentRestrictions.canBookmark,
            },
            on: {
              action: function ($event) {
                return _vm.$emit("bookmark")
              },
            },
          }),
          _vm._v(" "),
          _c("ToolBarActionButton", {
            attrs: {
              icon: "mdi-printer-outline",
              label: "Print",
              iconClass: "trigger-print-action text--secondary",
              allowed: _vm.contentRestrictions.canPrint,
            },
            on: {
              action: function ($event) {
                return _vm.$emit("print")
              },
            },
          }),
          _vm._v(" "),
          _c("ToolBarActionButton", {
            attrs: {
              icon: "mdi-link",
              label: "Copy link",
              iconClass: "trigger-share-action text--secondary",
              allowed: _vm.contentRestrictions.canShare,
            },
            on: {
              action: function ($event) {
                return _vm.$emit("share")
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-2 section-action-button-mobile disable-selection" },
        [
          _c(
            "v-btn",
            {
              staticClass: "float-right section-action-menu-trigger-mobile",
              attrs: {
                "aria-label": "Section Action Menu",
                icon: "",
                text: "",
                rounded: "",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("fireMobileActions")
                },
              },
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "notranslate",
                  attrs: { "aria-hidden": "true" },
                },
                [_vm._v("\n                mdi-dots-vertical\n            ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }